import { ReactElement } from 'react';
import Button from 'src/common/button/button';
import withErrorBoundaryWrapper from '../../common/error-boundary/with-error-boundary-wrapper';
import { GetFreeMaterialButtonConfigProps } from '../../common/get-free-material-button/get-free-material-button';
import cn from '../../utils/classnames';
import { Modal, ModalSize } from './modal';
import './shared-modal.scss';

type SharedModalProps = {
    onClose: () => void;
    title?: ReactElement;
    body?: ReactElement;
    btnConfig?: GetFreeMaterialButtonConfigProps['buttonConfig'];
    closeButton?: boolean;
    containerClassName?: string;
    backdropClassName?: string;
    dialogClassName?: string;
    size?: ModalSize;
    subsection?: ReactElement;
    closeOnOutsideClick?: boolean | 'static';
    footerPrefix?: ReactElement;
    centered?: boolean;
    enforceFocus?: boolean;
};

const SharedModal = (props: SharedModalProps) => {
    const {
        body,
        btnConfig,
        title,
        onClose,
        closeButton = true,
        containerClassName = '',
        backdropClassName = '',
        dialogClassName = '',
        subsection,
        closeOnOutsideClick = 'static',
        size,
        footerPrefix,
        centered,
        enforceFocus
    } = props;

    return (
        <Modal
            show
            size={size}
            centered={centered}
            enforceFocus={enforceFocus}
            backdrop={closeOnOutsideClick}
            backdropClassName={cn('shared-backdrop', { [backdropClassName]: backdropClassName })}
            dialogClassName={cn('shared-modal', { [dialogClassName]: dialogClassName, 'empty-body': !body })}
            onHide={onClose}
            className={cn('shared-modal-container', { [containerClassName]: containerClassName })}
        >
            <Modal.Header closeButton={closeButton}>
                {title && <div className='lmp-h-5 shared-modal-header'>{title}</div>}
            </Modal.Header>

            {Boolean(body) && (
                <Modal.Body>
                    <div className='shared-modal-body-container'>{body}</div>
                </Modal.Body>
            )}
            {(Boolean(btnConfig?.length) || Boolean(footerPrefix)) && (
                <Modal.Footer>
                    {footerPrefix}
                    {btnConfig?.map((btn) => (
                        <Button
                            key={btn.text as string}
                            className={`${btn.className} float-right`}
                            disabled={btn.disabled}
                            onClick={btn.action}
                        >
                            {btn.text}
                        </Button>
                    ))}
                </Modal.Footer>
            )}
            {subsection}
        </Modal>
    );
};

export default withErrorBoundaryWrapper(SharedModal, { withText: true });
